// @flow
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import { Router } from 'react-router-dom';
import type { RouterHistory} from 'react-router';
import { IntlProvider } from 'react-intl';
// import type { BrowserHistory } from 'history';
import type { Store } from '../types';
import { ClockProvider } from '../hooks/useNow';
import App from './App';

type Props = {
    history: RouterHistory,
    store: Store
};

function Main({ history, store }: Props) {
    return (
        <ReduxProvider store={store}>
            <Router history={history}>
                <IntlProvider locale="en">
                    <ClockProvider>
                        <App />
                    </ClockProvider>
                </IntlProvider>
            </Router>
        </ReduxProvider>
    );
}

export default hot(Main);